import { render, staticRenderFns } from "./ElementIconText.vue?vue&type=template&id=462d502a&"
import script from "./ElementIconText.vue?vue&type=script&lang=js&"
export * from "./ElementIconText.vue?vue&type=script&lang=js&"
import style0 from "./ElementIconText.vue?vue&type=style&index=0&id=462d502a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports